import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import CopyUid from "components/groups/CopyUid";
import DeleteAccountButton from "components/react-lib/firebase-auth/DeleteAccountButton";
import Loader from "components/react-lib/generic-ui/Loader";
import EditDocumentForm from "components/react-lib/generic-ui/firestore/EditDocumentForm";
import ReduxModal from "components/react-lib/generic-ui/modals/ReduxModal";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import { doc } from "firebase/firestore";
import { db } from "firebaseApp";
import React from "react";
import ModeSwitch from "./ModeSwitch";

export default function EditProfileModal() {

  const auth = useAuth();

  const renderContent = () => {

    if (!auth.currentUser) {
      return <Loader message="Loading profile data" />;
    }
    return (
      <Stack
        spacing={1}
      >
        <CopyUid />
        <ModeSwitch 
          color="secondary"
        />
        <EditDocumentForm
          documentRef={doc(db, "userPublicProfiles", auth.currentUser.uid)}
          schemaBuildData={{
            bucket: "userAvatars",
          }}
          fieldConfig={{
            username: {
              props: {
                color: "secondary",
              }
            },
          }}
        />
        <DeleteAccountButton
          color="secondary"
          variant="contained"
        />
      </Stack>
    );
  };

  return (
    <ReduxModal
      name="profile"
      title="Edit Profile"
      fullWidth
      maxWidth="sm"
    >
      {renderContent()}
    </ReduxModal>
  );
}
